import {Component, EventEmitter, Input, OnChanges, OnInit, Output,  SimpleChanges} from "@angular/core";
import {AbstractControl, FormArray, FormBuilder, FormGroup} from "@angular/forms";

class ButtonOption {
    id: any;
    label: string;

    constructor(id: any, label: string) {
        this.id = id;
        this.label = label;
    }
}

class ButtonConfig {
    clearOnAllSelected: boolean = true;
}

@Component({
    selector    : 'button-options',
    template: require('./button-options.component.html'),
    styles: [require('./button-options.component.scss')]
})

class ButtonOptionsComponent implements OnInit, OnChanges {
    @Input()  options: ButtonOption[]     = [];
    @Input()  entity: any[]               = [];
    @Input()  config: ButtonConfig        = new ButtonConfig();

    @Output() change: EventEmitter<any[]> = new EventEmitter();

    protected buttonOptions: FormGroup;
    protected buttonGroup: FormArray;
    protected optionList: any[] = [];

    constructor(private fb: FormBuilder) {}

    public ngOnInit() {
        this.options.forEach((option: ButtonOption) => {
            this.optionList.push(option.id);
        });

        this.buttonOptions = this.fb.group({
            options: this.fb.array([])
        });

        this.buildGroup();
    }

    ngOnChanges(simpleChanges: SimpleChanges): void {
        if (simpleChanges.entity && simpleChanges.entity.firstChange === false) {
            this.buildGroup();
        }
    }

    private buildGroup() {
        this.buttonGroup = this.fb.array([]);
        this.options.forEach((option: ButtonOption) => {
            this.buttonGroup.push(this.fb.control(this.entity.indexOf(option.id) > -1))
        });

        this.buttonGroup.valueChanges.subscribe(() => {
            this.entity.splice(0, this.entity.length);

            this.buttonGroup.controls.forEach((control: AbstractControl, index: number) => {
                if (control.value === true) {
                    this.entity.push(this.options[index].id);
                }
            });


            if (this.config.clearOnAllSelected === true && this.optionList.length === this.entity.length) {
                this.entity.splice(0, this.entity.length);

                window.setTimeout(() => {
                    this.buildGroup();
                }, 100);
            }

            this.change.emit(this.entity);
        });

        this.buttonOptions.setControl('options', this.buttonGroup);
    }
}

export {
    ButtonOption,
    ButtonConfig,
    ButtonOptionsComponent
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/button-options.component.ts